import { EPageTypes, EPlatformTypes, handleDynamicCalltracking } from '@cian/frontend-newbuilding-call-component';
import { Button } from '@cian/ui-kit';
import * as React from 'react';

import { useApplicationContext } from 'shared/utils/applicationContext';
import { phoneToFormat } from './utils/phoneToFormat';

interface ISellerPhoneProps {
  blockId?: number | null;
  children: string;
  isOpen: boolean;
  phone: string;
  placeType: string;
  onClick?: () => void;
}

export const SellerPhone: React.FC<ISellerPhoneProps> = props => {
  const { blockId, children, isOpen, phone, placeType, onClick } = props;
  const [dynamicPhone, setDynamicPhone] = React.useState('');
  const { httpApi, logger } = useApplicationContext();

  const loadDynamicPhone = React.useCallback(async () => {
    let dynamicPhone = null;

    if (blockId) {
      const response = await handleDynamicCalltracking({
        logger,
        httpApi,
        blockId,
        platformType: EPlatformTypes.WebMobile,
        pageType: EPageTypes.NewbuildingCard,
        placeType,
      });

      dynamicPhone = phoneToFormat(response.notFormattedPhone);
    }

    if (onClick) {
      onClick();
    }

    setDynamicPhone(dynamicPhone || phone);
  }, [blockId, logger, httpApi, placeType, onClick, phone]);

  const handleDynamicPhoneClick = React.useCallback(
    () => (window.location.href = `tel:${dynamicPhone}`),
    [dynamicPhone],
  );

  return (
    <Button theme="fill_secondary" size="XS" onClick={isOpen ? handleDynamicPhoneClick : loadDynamicPhone}>
      {dynamicPhone || children}
    </Button>
  );
};
